import React from 'react'
import {useParams} from 'react-router-dom'
import clientsInfo from '../data/clients.json'
import {Link} from 'react-router-dom'
import {v4} from 'uuid'

import * as clients from '../data/clients/ClientsProvider'

function ClientItem() {
    const {clientName} = useParams()

    console.log(clientName)

    let clientData
    let similarCompanies = []

    // for (let client of clients){
    //     console.log(client)
    // }

    // console.log(clients[clientName])

    let ClientComponent = clients[clientName] ? clients[clientName] : () => <div>Пока не подготовили кейс, но мы в
        процессе...</div>


    if (clientsInfo.length > 0) {
        clientData = clientsInfo.find((item) => item.name === clientName)

        for (let otherClient of clientsInfo) {
            // Check if the other client is not the same as the current client and has products
            if (otherClient.name !== clientName && otherClient.products) {
                // Check if there are common products
                const commonProducts = clientData.products.filter((product) => otherClient.products.includes(product))

                // If there are common products, add the other client's name to similarCompanies array
                if (commonProducts.length > 0) {
                    similarCompanies.push({name: otherClient.name, normalName: otherClient.normalName})
                }
            }
        }
    }

    console.log(clientData)

    return (
        <div>
            {clientData ? (
                <div className="client-info-container-outer" style={{overflow: 'hidden'}}>
                    <Link to="../clients" className="client-info-container__back-button tp-underline">
                        Назад к списку
                    </Link>
                    <div className="client-info-container main-text block added-shadow added-shadow--var2">
                        <div className="client-info-header">
                            <div
                                className="clientsList-logo"
                                style={{backgroundImage: `url(${require(`../images/client-logos/${clientData.name}.png`)})`}}
                            ></div>
                            <div className="clientsList-tags">
                                <h3>Полученные услуги</h3> <br/>
                                <div className="client-info__products">
                                    {clientData.products.map((el) => (
                                        <Link
                                            to={`/product/${encodeURIComponent(el)}`}
                                            key={v4()}
                                            className="main-text main-text--sm client-info__product-link"
                                        >
                                            {el}
                                        </Link>
                                    ))}
                                </div>

                                <div className={'clientsList-reviews'}>
                                    <h3>Отзыв</h3>

                                    {clientData.review && clientData.review.length>0 && clientData.review.map((el, index) => {
                                        const length = clientData.review.length

                                        if (el.type === 'file'){
                                            return (
                                                <a href={`/reviews/${el.url}`} download target="_blank"
                                                   rel="noopener noreferrer" key={v4()}>
                                                    Скачать отзыв
                                                </a>
                                            )
                                        }

                                        if (el.type === 'link'){
                                            return (
                                                <a href={el.url} target="_blank"
                                                   rel="noopener noreferrer" key={v4()}>
                                                    Просмотреть отзыв {
                                                    length > 1 && `№${index+1}`
                                                }
                                                </a>
                                            )
                                        }

                                    })

                                    }
                                </div>
                            </div>
                        </div>
                        <div className="client-info-body"><ClientComponent/></div>
                        <hr/>
                        <h3>Эти же услуги заказывали для себя:</h3>
                        <div className="similarCompaniesList">
                            {similarCompanies.map((company) => (
                                <span>
                                    <Link to={`/clients/${company.name}`} key={v4()}>
                                        {company.normalName}
                                    </Link>{'    '}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                'Загрузка данных'
            )}
        </div>
    )
}

export default ClientItem
